var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-page',[(_vm.step === 1)?_c('w-user-account-recovery-one'):_vm._e(),(_vm.step === 2)?_c('w-user-account-recovery-two'):_vm._e(),(_vm.step === 3)?_c('w-user-account-recovery-three'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }